import { default as indexYIrkBmJXXeMeta } from "/vercel/path0/pages/admin/about-us/index.vue?macro=true";
import { default as index0YhAgkahE3Meta } from "/vercel/path0/pages/admin/categories/index.vue?macro=true";
import { default as indexaBhUl69XlGMeta } from "/vercel/path0/pages/admin/contact-us/index.vue?macro=true";
import { default as indexBRSVzAvv5QMeta } from "/vercel/path0/pages/admin/dev-tickets/index.vue?macro=true";
import { default as _91page_93hD6BdkSUPxMeta } from "/vercel/path0/pages/admin/dev-tickets/page/[page].vue?macro=true";
import { default as indexG7R2Mya2P4Meta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as loginnB6F0vreEVMeta } from "/vercel/path0/pages/admin/login.vue?macro=true";
import { default as index60rHiP13BnMeta } from "/vercel/path0/pages/admin/logs/index.vue?macro=true";
import { default as _91page_93ia5xiAi1F6Meta } from "/vercel/path0/pages/admin/logs/page/[page].vue?macro=true";
import { default as indexSgSbxEUuasMeta } from "/vercel/path0/pages/admin/metas/index.vue?macro=true";
import { default as _91postId_93vZujNTUG3cMeta } from "/vercel/path0/pages/admin/posts/[postId].vue?macro=true";
import { default as createlcOSXWP82JMeta } from "/vercel/path0/pages/admin/posts/create.vue?macro=true";
import { default as indexCJmAiJdkFbMeta } from "/vercel/path0/pages/admin/posts/index.vue?macro=true";
import { default as _91page_93fzGqiJDztEMeta } from "/vercel/path0/pages/admin/posts/page/[page].vue?macro=true";
import { default as reportszwRqbqNKv2Meta } from "/vercel/path0/pages/admin/reports.vue?macro=true";
import { default as indexrn7Wgy9qnLMeta } from "/vercel/path0/pages/admin/rules/index.vue?macro=true";
import { default as indexAt5FMczD4MMeta } from "/vercel/path0/pages/admin/slides/index.vue?macro=true";
import { default as indexgxZ1ikbUBwMeta } from "/vercel/path0/pages/admin/users/index.vue?macro=true";
import { default as _91page_93BSiAgdc1GeMeta } from "/vercel/path0/pages/admin/users/page/[page].vue?macro=true";
import { default as indexkppHktB81xMeta } from "/vercel/path0/pages/auth/index.vue?macro=true";
import { default as startbAaxN4cIFOMeta } from "/vercel/path0/pages/auth/start.vue?macro=true";
import { default as addizGUryB5tAMeta } from "/vercel/path0/pages/businesses/[businessId]/ads/add.vue?macro=true";
import { default as indexk7YPviQEUiMeta } from "/vercel/path0/pages/businesses/[businessId]/ads/index.vue?macro=true";
import { default as _91userId_93PRqovTbHJtMeta } from "/vercel/path0/pages/businesses/[businessId]/direct-messages/[userId].vue?macro=true";
import { default as indexDknWWcQp12Meta } from "/vercel/path0/pages/businesses/[businessId]/direct-messages/index.vue?macro=true";
import { default as sendMHCvqYYTwRMeta } from "/vercel/path0/pages/businesses/[businessId]/direct-messages/send.vue?macro=true";
import { default as editKFmt7jV2ylMeta } from "/vercel/path0/pages/businesses/[businessId]/edit.vue?macro=true";
import { default as indextPAL2GbSH8Meta } from "/vercel/path0/pages/businesses/[businessId]/index.vue?macro=true";
import { default as notifications6XxFKjsryPMeta } from "/vercel/path0/pages/businesses/[businessId]/notifications.vue?macro=true";
import { default as pageCkDilDiXJQMeta } from "/vercel/path0/pages/businesses/[businessId]/page.vue?macro=true";
import { default as addPpW3qKQt2KMeta } from "/vercel/path0/pages/businesses/[businessId]/posts/add.vue?macro=true";
import { default as edit_45_91postId_9316tgjpImEUMeta } from "/vercel/path0/pages/businesses/[businessId]/posts/edit-[postId].vue?macro=true";
import { default as indexfdK1PgSNUaMeta } from "/vercel/path0/pages/businesses/[businessId]/posts/index.vue?macro=true";
import { default as add2LWKUvKE3kMeta } from "/vercel/path0/pages/businesses/add.vue?macro=true";
import { default as demo8GGAMPL777Meta } from "/vercel/path0/pages/demo.vue?macro=true";
import { default as _91userId_937nMb09js4GMeta } from "/vercel/path0/pages/direct-messages/[userId].vue?macro=true";
import { default as indexi0HGY37FeDMeta } from "/vercel/path0/pages/direct-messages/index.vue?macro=true";
import { default as sendDcLEITcQZ7Meta } from "/vercel/path0/pages/direct-messages/send.vue?macro=true";
import { default as discoverDujjR35yg8Meta } from "/vercel/path0/pages/discover.vue?macro=true";
import { default as helpgTNWcaY3gjMeta } from "/vercel/path0/pages/help.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as landingIrNCINQjz2Meta } from "/vercel/path0/pages/landing.vue?macro=true";
import { default as notifications0zKhVpcel9Meta } from "/vercel/path0/pages/notifications.vue?macro=true";
import { default as attendeesm4BNkSvPckMeta } from "/vercel/path0/pages/posts/[postId]/attendees.vue?macro=true";
import { default as index3AqaOgMT83Meta } from "/vercel/path0/pages/posts/[postId]/index.vue?macro=true";
import { default as add55BC4qTxsnMeta } from "/vercel/path0/pages/posts/add.vue?macro=true";
import { default as edit_45_91postId_93wYFIve3AVeMeta } from "/vercel/path0/pages/posts/edit-[postId].vue?macro=true";
import { default as privacy_45policyQl0qlywOJTMeta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as searchBIFC2dE21WMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as settingsyZZu4Rd1aAMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as sharev8ONwuKEHBMeta } from "/vercel/path0/pages/share.vue?macro=true";
import { default as _91postId_93UW2cTg4ZYnMeta } from "/vercel/path0/pages/shop/[postId].vue?macro=true";
import { default as indexN8QAORuvpUMeta } from "/vercel/path0/pages/shop/index.vue?macro=true";
import { default as searchgSssxvzn2XMeta } from "/vercel/path0/pages/shop/search.vue?macro=true";
import { default as your_45listingsPp77OC4TFSMeta } from "/vercel/path0/pages/shop/your-listings.vue?macro=true";
import { default as terms_45of_45serviceSmXvkgSRNCMeta } from "/vercel/path0/pages/terms-of-service.vue?macro=true";
import { default as _91userId_93KP0CRlFGhfMeta } from "/vercel/path0/pages/users/[userId].vue?macro=true";
import { default as change_45passwordXP5gtLQeHOMeta } from "/vercel/path0/pages/users/change-password.vue?macro=true";
import { default as edit_45privacy_45settingsn8W1JMyioCMeta } from "/vercel/path0/pages/users/edit-privacy-settings.vue?macro=true";
import { default as edit_45profilecVOybfZorQMeta } from "/vercel/path0/pages/users/edit-profile.vue?macro=true";
import { default as blocked_45usersboyumMiH3DMeta } from "/vercel/path0/pages/users/profile/blocked-users.vue?macro=true";
import { default as connectionst8syvFbgl5Meta } from "/vercel/path0/pages/users/profile/connections.vue?macro=true";
import { default as eventszWIiS0JfhMMeta } from "/vercel/path0/pages/users/profile/events.vue?macro=true";
import { default as faved_45businessesuhp3KdNpITMeta } from "/vercel/path0/pages/users/profile/faved-businesses.vue?macro=true";
import { default as indexsLYt1VEImkMeta } from "/vercel/path0/pages/users/profile/index.vue?macro=true";
import { default as liked_45postsalNbS8FUzRMeta } from "/vercel/path0/pages/users/profile/liked-posts.vue?macro=true";
import { default as waiting_45for_45removalpjGYgQBYZ5Meta } from "/vercel/path0/pages/users/waiting-for-removal.vue?macro=true";
export default [
  {
    name: indexYIrkBmJXXeMeta?.name ?? "admin-about-us",
    path: indexYIrkBmJXXeMeta?.path ?? "/admin/about-us",
    meta: indexYIrkBmJXXeMeta || {},
    alias: indexYIrkBmJXXeMeta?.alias || [],
    redirect: indexYIrkBmJXXeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: index0YhAgkahE3Meta?.name ?? "admin-categories",
    path: index0YhAgkahE3Meta?.path ?? "/admin/categories",
    meta: index0YhAgkahE3Meta || {},
    alias: index0YhAgkahE3Meta?.alias || [],
    redirect: index0YhAgkahE3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/categories/index.vue").then(m => m.default || m)
  },
  {
    name: indexaBhUl69XlGMeta?.name ?? "admin-contact-us",
    path: indexaBhUl69XlGMeta?.path ?? "/admin/contact-us",
    meta: indexaBhUl69XlGMeta || {},
    alias: indexaBhUl69XlGMeta?.alias || [],
    redirect: indexaBhUl69XlGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexBRSVzAvv5QMeta?.name ?? "admin-dev-tickets",
    path: indexBRSVzAvv5QMeta?.path ?? "/admin/dev-tickets",
    meta: indexBRSVzAvv5QMeta || {},
    alias: indexBRSVzAvv5QMeta?.alias || [],
    redirect: indexBRSVzAvv5QMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/dev-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93hD6BdkSUPxMeta?.name ?? "admin-dev-tickets-page-page",
    path: _91page_93hD6BdkSUPxMeta?.path ?? "/admin/dev-tickets/page/:page()",
    meta: _91page_93hD6BdkSUPxMeta || {},
    alias: _91page_93hD6BdkSUPxMeta?.alias || [],
    redirect: _91page_93hD6BdkSUPxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/dev-tickets/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexG7R2Mya2P4Meta?.name ?? "admin",
    path: indexG7R2Mya2P4Meta?.path ?? "/admin",
    meta: indexG7R2Mya2P4Meta || {},
    alias: indexG7R2Mya2P4Meta?.alias || [],
    redirect: indexG7R2Mya2P4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: loginnB6F0vreEVMeta?.name ?? "admin-login",
    path: loginnB6F0vreEVMeta?.path ?? "/admin/login",
    meta: loginnB6F0vreEVMeta || {},
    alias: loginnB6F0vreEVMeta?.alias || [],
    redirect: loginnB6F0vreEVMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: index60rHiP13BnMeta?.name ?? "admin-logs",
    path: index60rHiP13BnMeta?.path ?? "/admin/logs",
    meta: index60rHiP13BnMeta || {},
    alias: index60rHiP13BnMeta?.alias || [],
    redirect: index60rHiP13BnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/logs/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93ia5xiAi1F6Meta?.name ?? "admin-logs-page-page",
    path: _91page_93ia5xiAi1F6Meta?.path ?? "/admin/logs/page/:page()",
    meta: _91page_93ia5xiAi1F6Meta || {},
    alias: _91page_93ia5xiAi1F6Meta?.alias || [],
    redirect: _91page_93ia5xiAi1F6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/logs/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexSgSbxEUuasMeta?.name ?? "admin-metas",
    path: indexSgSbxEUuasMeta?.path ?? "/admin/metas",
    meta: indexSgSbxEUuasMeta || {},
    alias: indexSgSbxEUuasMeta?.alias || [],
    redirect: indexSgSbxEUuasMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/metas/index.vue").then(m => m.default || m)
  },
  {
    name: _91postId_93vZujNTUG3cMeta?.name ?? "admin-posts-postId",
    path: _91postId_93vZujNTUG3cMeta?.path ?? "/admin/posts/:postId()",
    meta: _91postId_93vZujNTUG3cMeta || {},
    alias: _91postId_93vZujNTUG3cMeta?.alias || [],
    redirect: _91postId_93vZujNTUG3cMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/posts/[postId].vue").then(m => m.default || m)
  },
  {
    name: createlcOSXWP82JMeta?.name ?? "admin-posts-create",
    path: createlcOSXWP82JMeta?.path ?? "/admin/posts/create",
    meta: createlcOSXWP82JMeta || {},
    alias: createlcOSXWP82JMeta?.alias || [],
    redirect: createlcOSXWP82JMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/posts/create.vue").then(m => m.default || m)
  },
  {
    name: indexCJmAiJdkFbMeta?.name ?? "admin-posts",
    path: indexCJmAiJdkFbMeta?.path ?? "/admin/posts",
    meta: indexCJmAiJdkFbMeta || {},
    alias: indexCJmAiJdkFbMeta?.alias || [],
    redirect: indexCJmAiJdkFbMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/posts/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93fzGqiJDztEMeta?.name ?? "admin-posts-page-page",
    path: _91page_93fzGqiJDztEMeta?.path ?? "/admin/posts/page/:page()",
    meta: _91page_93fzGqiJDztEMeta || {},
    alias: _91page_93fzGqiJDztEMeta?.alias || [],
    redirect: _91page_93fzGqiJDztEMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/posts/page/[page].vue").then(m => m.default || m)
  },
  {
    name: reportszwRqbqNKv2Meta?.name ?? "admin-reports",
    path: reportszwRqbqNKv2Meta?.path ?? "/admin/reports",
    meta: reportszwRqbqNKv2Meta || {},
    alias: reportszwRqbqNKv2Meta?.alias || [],
    redirect: reportszwRqbqNKv2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/reports.vue").then(m => m.default || m)
  },
  {
    name: indexrn7Wgy9qnLMeta?.name ?? "admin-rules",
    path: indexrn7Wgy9qnLMeta?.path ?? "/admin/rules",
    meta: indexrn7Wgy9qnLMeta || {},
    alias: indexrn7Wgy9qnLMeta?.alias || [],
    redirect: indexrn7Wgy9qnLMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/rules/index.vue").then(m => m.default || m)
  },
  {
    name: indexAt5FMczD4MMeta?.name ?? "admin-slides",
    path: indexAt5FMczD4MMeta?.path ?? "/admin/slides",
    meta: indexAt5FMczD4MMeta || {},
    alias: indexAt5FMczD4MMeta?.alias || [],
    redirect: indexAt5FMczD4MMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/slides/index.vue").then(m => m.default || m)
  },
  {
    name: indexgxZ1ikbUBwMeta?.name ?? "admin-users",
    path: indexgxZ1ikbUBwMeta?.path ?? "/admin/users",
    meta: indexgxZ1ikbUBwMeta || {},
    alias: indexgxZ1ikbUBwMeta?.alias || [],
    redirect: indexgxZ1ikbUBwMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93BSiAgdc1GeMeta?.name ?? "admin-users-page-page",
    path: _91page_93BSiAgdc1GeMeta?.path ?? "/admin/users/page/:page()",
    meta: _91page_93BSiAgdc1GeMeta || {},
    alias: _91page_93BSiAgdc1GeMeta?.alias || [],
    redirect: _91page_93BSiAgdc1GeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/admin/users/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexkppHktB81xMeta?.name ?? "auth",
    path: indexkppHktB81xMeta?.path ?? "/auth",
    meta: indexkppHktB81xMeta || {},
    alias: indexkppHktB81xMeta?.alias || [],
    redirect: indexkppHktB81xMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: startbAaxN4cIFOMeta?.name ?? "auth-start",
    path: startbAaxN4cIFOMeta?.path ?? "/auth/start",
    meta: startbAaxN4cIFOMeta || {},
    alias: startbAaxN4cIFOMeta?.alias || [],
    redirect: startbAaxN4cIFOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/start.vue").then(m => m.default || m)
  },
  {
    name: addizGUryB5tAMeta?.name ?? "businesses-businessId-ads-add",
    path: addizGUryB5tAMeta?.path ?? "/businesses/:businessId()/ads/add",
    meta: addizGUryB5tAMeta || {},
    alias: addizGUryB5tAMeta?.alias || [],
    redirect: addizGUryB5tAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/ads/add.vue").then(m => m.default || m)
  },
  {
    name: indexk7YPviQEUiMeta?.name ?? "businesses-businessId-ads",
    path: indexk7YPviQEUiMeta?.path ?? "/businesses/:businessId()/ads",
    meta: indexk7YPviQEUiMeta || {},
    alias: indexk7YPviQEUiMeta?.alias || [],
    redirect: indexk7YPviQEUiMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/ads/index.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93PRqovTbHJtMeta?.name ?? "businesses-businessId-direct-messages-userId",
    path: _91userId_93PRqovTbHJtMeta?.path ?? "/businesses/:businessId()/direct-messages/:userId()",
    meta: _91userId_93PRqovTbHJtMeta || {},
    alias: _91userId_93PRqovTbHJtMeta?.alias || [],
    redirect: _91userId_93PRqovTbHJtMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/direct-messages/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexDknWWcQp12Meta?.name ?? "businesses-businessId-direct-messages",
    path: indexDknWWcQp12Meta?.path ?? "/businesses/:businessId()/direct-messages",
    meta: indexDknWWcQp12Meta || {},
    alias: indexDknWWcQp12Meta?.alias || [],
    redirect: indexDknWWcQp12Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/direct-messages/index.vue").then(m => m.default || m)
  },
  {
    name: sendMHCvqYYTwRMeta?.name ?? "businesses-businessId-direct-messages-send",
    path: sendMHCvqYYTwRMeta?.path ?? "/businesses/:businessId()/direct-messages/send",
    meta: sendMHCvqYYTwRMeta || {},
    alias: sendMHCvqYYTwRMeta?.alias || [],
    redirect: sendMHCvqYYTwRMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/direct-messages/send.vue").then(m => m.default || m)
  },
  {
    name: editKFmt7jV2ylMeta?.name ?? "businesses-businessId-edit",
    path: editKFmt7jV2ylMeta?.path ?? "/businesses/:businessId()/edit",
    meta: editKFmt7jV2ylMeta || {},
    alias: editKFmt7jV2ylMeta?.alias || [],
    redirect: editKFmt7jV2ylMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/edit.vue").then(m => m.default || m)
  },
  {
    name: indextPAL2GbSH8Meta?.name ?? "businesses-businessId",
    path: indextPAL2GbSH8Meta?.path ?? "/businesses/:businessId()",
    meta: indextPAL2GbSH8Meta || {},
    alias: indextPAL2GbSH8Meta?.alias || [],
    redirect: indextPAL2GbSH8Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/index.vue").then(m => m.default || m)
  },
  {
    name: notifications6XxFKjsryPMeta?.name ?? "businesses-businessId-notifications",
    path: notifications6XxFKjsryPMeta?.path ?? "/businesses/:businessId()/notifications",
    meta: notifications6XxFKjsryPMeta || {},
    alias: notifications6XxFKjsryPMeta?.alias || [],
    redirect: notifications6XxFKjsryPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/notifications.vue").then(m => m.default || m)
  },
  {
    name: pageCkDilDiXJQMeta?.name ?? "businesses-businessId-page",
    path: pageCkDilDiXJQMeta?.path ?? "/businesses/:businessId()/page",
    meta: pageCkDilDiXJQMeta || {},
    alias: pageCkDilDiXJQMeta?.alias || [],
    redirect: pageCkDilDiXJQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/page.vue").then(m => m.default || m)
  },
  {
    name: addPpW3qKQt2KMeta?.name ?? "businesses-businessId-posts-add",
    path: addPpW3qKQt2KMeta?.path ?? "/businesses/:businessId()/posts/add",
    meta: addPpW3qKQt2KMeta || {},
    alias: addPpW3qKQt2KMeta?.alias || [],
    redirect: addPpW3qKQt2KMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/posts/add.vue").then(m => m.default || m)
  },
  {
    name: edit_45_91postId_9316tgjpImEUMeta?.name ?? "businesses-businessId-posts-edit-postId",
    path: edit_45_91postId_9316tgjpImEUMeta?.path ?? "/businesses/:businessId()/posts/edit-:postId()",
    meta: edit_45_91postId_9316tgjpImEUMeta || {},
    alias: edit_45_91postId_9316tgjpImEUMeta?.alias || [],
    redirect: edit_45_91postId_9316tgjpImEUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/posts/edit-[postId].vue").then(m => m.default || m)
  },
  {
    name: indexfdK1PgSNUaMeta?.name ?? "businesses-businessId-posts",
    path: indexfdK1PgSNUaMeta?.path ?? "/businesses/:businessId()/posts",
    meta: indexfdK1PgSNUaMeta || {},
    alias: indexfdK1PgSNUaMeta?.alias || [],
    redirect: indexfdK1PgSNUaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/[businessId]/posts/index.vue").then(m => m.default || m)
  },
  {
    name: add2LWKUvKE3kMeta?.name ?? "businesses-add",
    path: add2LWKUvKE3kMeta?.path ?? "/businesses/add",
    meta: add2LWKUvKE3kMeta || {},
    alias: add2LWKUvKE3kMeta?.alias || [],
    redirect: add2LWKUvKE3kMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/businesses/add.vue").then(m => m.default || m)
  },
  {
    name: demo8GGAMPL777Meta?.name ?? "demo",
    path: demo8GGAMPL777Meta?.path ?? "/demo",
    meta: demo8GGAMPL777Meta || {},
    alias: demo8GGAMPL777Meta?.alias || [],
    redirect: demo8GGAMPL777Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/demo.vue").then(m => m.default || m)
  },
  {
    name: _91userId_937nMb09js4GMeta?.name ?? "direct-messages-userId",
    path: _91userId_937nMb09js4GMeta?.path ?? "/direct-messages/:userId()",
    meta: _91userId_937nMb09js4GMeta || {},
    alias: _91userId_937nMb09js4GMeta?.alias || [],
    redirect: _91userId_937nMb09js4GMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/direct-messages/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexi0HGY37FeDMeta?.name ?? "direct-messages",
    path: indexi0HGY37FeDMeta?.path ?? "/direct-messages",
    meta: indexi0HGY37FeDMeta || {},
    alias: indexi0HGY37FeDMeta?.alias || [],
    redirect: indexi0HGY37FeDMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/direct-messages/index.vue").then(m => m.default || m)
  },
  {
    name: sendDcLEITcQZ7Meta?.name ?? "direct-messages-send",
    path: sendDcLEITcQZ7Meta?.path ?? "/direct-messages/send",
    meta: sendDcLEITcQZ7Meta || {},
    alias: sendDcLEITcQZ7Meta?.alias || [],
    redirect: sendDcLEITcQZ7Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/direct-messages/send.vue").then(m => m.default || m)
  },
  {
    name: discoverDujjR35yg8Meta?.name ?? "discover",
    path: discoverDujjR35yg8Meta?.path ?? "/discover",
    meta: discoverDujjR35yg8Meta || {},
    alias: discoverDujjR35yg8Meta?.alias || [],
    redirect: discoverDujjR35yg8Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/discover.vue").then(m => m.default || m)
  },
  {
    name: helpgTNWcaY3gjMeta?.name ?? "help",
    path: helpgTNWcaY3gjMeta?.path ?? "/help",
    meta: helpgTNWcaY3gjMeta || {},
    alias: helpgTNWcaY3gjMeta?.alias || [],
    redirect: helpgTNWcaY3gjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/help.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: landingIrNCINQjz2Meta?.name ?? "landing",
    path: landingIrNCINQjz2Meta?.path ?? "/landing",
    meta: landingIrNCINQjz2Meta || {},
    alias: landingIrNCINQjz2Meta?.alias || [],
    redirect: landingIrNCINQjz2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/landing.vue").then(m => m.default || m)
  },
  {
    name: notifications0zKhVpcel9Meta?.name ?? "notifications",
    path: notifications0zKhVpcel9Meta?.path ?? "/notifications",
    meta: notifications0zKhVpcel9Meta || {},
    alias: notifications0zKhVpcel9Meta?.alias || [],
    redirect: notifications0zKhVpcel9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/notifications.vue").then(m => m.default || m)
  },
  {
    name: attendeesm4BNkSvPckMeta?.name ?? "posts-postId-attendees",
    path: attendeesm4BNkSvPckMeta?.path ?? "/posts/:postId()/attendees",
    meta: attendeesm4BNkSvPckMeta || {},
    alias: attendeesm4BNkSvPckMeta?.alias || [],
    redirect: attendeesm4BNkSvPckMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/posts/[postId]/attendees.vue").then(m => m.default || m)
  },
  {
    name: index3AqaOgMT83Meta?.name ?? "posts-postId",
    path: index3AqaOgMT83Meta?.path ?? "/posts/:postId()",
    meta: index3AqaOgMT83Meta || {},
    alias: index3AqaOgMT83Meta?.alias || [],
    redirect: index3AqaOgMT83Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/posts/[postId]/index.vue").then(m => m.default || m)
  },
  {
    name: add55BC4qTxsnMeta?.name ?? "posts-add",
    path: add55BC4qTxsnMeta?.path ?? "/posts/add",
    meta: add55BC4qTxsnMeta || {},
    alias: add55BC4qTxsnMeta?.alias || [],
    redirect: add55BC4qTxsnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/posts/add.vue").then(m => m.default || m)
  },
  {
    name: edit_45_91postId_93wYFIve3AVeMeta?.name ?? "posts-edit-postId",
    path: edit_45_91postId_93wYFIve3AVeMeta?.path ?? "/posts/edit-:postId()",
    meta: edit_45_91postId_93wYFIve3AVeMeta || {},
    alias: edit_45_91postId_93wYFIve3AVeMeta?.alias || [],
    redirect: edit_45_91postId_93wYFIve3AVeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/posts/edit-[postId].vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyQl0qlywOJTMeta?.name ?? "privacy-policy",
    path: privacy_45policyQl0qlywOJTMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyQl0qlywOJTMeta || {},
    alias: privacy_45policyQl0qlywOJTMeta?.alias || [],
    redirect: privacy_45policyQl0qlywOJTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: searchBIFC2dE21WMeta?.name ?? "search",
    path: searchBIFC2dE21WMeta?.path ?? "/search",
    meta: searchBIFC2dE21WMeta || {},
    alias: searchBIFC2dE21WMeta?.alias || [],
    redirect: searchBIFC2dE21WMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/search.vue").then(m => m.default || m)
  },
  {
    name: settingsyZZu4Rd1aAMeta?.name ?? "settings",
    path: settingsyZZu4Rd1aAMeta?.path ?? "/settings",
    meta: settingsyZZu4Rd1aAMeta || {},
    alias: settingsyZZu4Rd1aAMeta?.alias || [],
    redirect: settingsyZZu4Rd1aAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/settings.vue").then(m => m.default || m)
  },
  {
    name: sharev8ONwuKEHBMeta?.name ?? "share",
    path: sharev8ONwuKEHBMeta?.path ?? "/share",
    meta: sharev8ONwuKEHBMeta || {},
    alias: sharev8ONwuKEHBMeta?.alias || [],
    redirect: sharev8ONwuKEHBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/share.vue").then(m => m.default || m)
  },
  {
    name: _91postId_93UW2cTg4ZYnMeta?.name ?? "shop-postId",
    path: _91postId_93UW2cTg4ZYnMeta?.path ?? "/shop/:postId()",
    meta: _91postId_93UW2cTg4ZYnMeta || {},
    alias: _91postId_93UW2cTg4ZYnMeta?.alias || [],
    redirect: _91postId_93UW2cTg4ZYnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shop/[postId].vue").then(m => m.default || m)
  },
  {
    name: indexN8QAORuvpUMeta?.name ?? "shop",
    path: indexN8QAORuvpUMeta?.path ?? "/shop",
    meta: indexN8QAORuvpUMeta || {},
    alias: indexN8QAORuvpUMeta?.alias || [],
    redirect: indexN8QAORuvpUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shop/index.vue").then(m => m.default || m)
  },
  {
    name: searchgSssxvzn2XMeta?.name ?? "shop-search",
    path: searchgSssxvzn2XMeta?.path ?? "/shop/search",
    meta: searchgSssxvzn2XMeta || {},
    alias: searchgSssxvzn2XMeta?.alias || [],
    redirect: searchgSssxvzn2XMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shop/search.vue").then(m => m.default || m)
  },
  {
    name: your_45listingsPp77OC4TFSMeta?.name ?? "shop-your-listings",
    path: your_45listingsPp77OC4TFSMeta?.path ?? "/shop/your-listings",
    meta: your_45listingsPp77OC4TFSMeta || {},
    alias: your_45listingsPp77OC4TFSMeta?.alias || [],
    redirect: your_45listingsPp77OC4TFSMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shop/your-listings.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45serviceSmXvkgSRNCMeta?.name ?? "terms-of-service",
    path: terms_45of_45serviceSmXvkgSRNCMeta?.path ?? "/terms-of-service",
    meta: terms_45of_45serviceSmXvkgSRNCMeta || {},
    alias: terms_45of_45serviceSmXvkgSRNCMeta?.alias || [],
    redirect: terms_45of_45serviceSmXvkgSRNCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93KP0CRlFGhfMeta?.name ?? "users-userId",
    path: _91userId_93KP0CRlFGhfMeta?.path ?? "/users/:userId()",
    meta: _91userId_93KP0CRlFGhfMeta || {},
    alias: _91userId_93KP0CRlFGhfMeta?.alias || [],
    redirect: _91userId_93KP0CRlFGhfMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: change_45passwordXP5gtLQeHOMeta?.name ?? "users-change-password",
    path: change_45passwordXP5gtLQeHOMeta?.path ?? "/users/change-password",
    meta: change_45passwordXP5gtLQeHOMeta || {},
    alias: change_45passwordXP5gtLQeHOMeta?.alias || [],
    redirect: change_45passwordXP5gtLQeHOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/change-password.vue").then(m => m.default || m)
  },
  {
    name: edit_45privacy_45settingsn8W1JMyioCMeta?.name ?? "users-edit-privacy-settings",
    path: edit_45privacy_45settingsn8W1JMyioCMeta?.path ?? "/users/edit-privacy-settings",
    meta: edit_45privacy_45settingsn8W1JMyioCMeta || {},
    alias: edit_45privacy_45settingsn8W1JMyioCMeta?.alias || [],
    redirect: edit_45privacy_45settingsn8W1JMyioCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/edit-privacy-settings.vue").then(m => m.default || m)
  },
  {
    name: edit_45profilecVOybfZorQMeta?.name ?? "users-edit-profile",
    path: edit_45profilecVOybfZorQMeta?.path ?? "/users/edit-profile",
    meta: edit_45profilecVOybfZorQMeta || {},
    alias: edit_45profilecVOybfZorQMeta?.alias || [],
    redirect: edit_45profilecVOybfZorQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/edit-profile.vue").then(m => m.default || m)
  },
  {
    name: blocked_45usersboyumMiH3DMeta?.name ?? "users-profile-blocked-users",
    path: blocked_45usersboyumMiH3DMeta?.path ?? "/users/profile/blocked-users",
    meta: blocked_45usersboyumMiH3DMeta || {},
    alias: blocked_45usersboyumMiH3DMeta?.alias || [],
    redirect: blocked_45usersboyumMiH3DMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/blocked-users.vue").then(m => m.default || m)
  },
  {
    name: connectionst8syvFbgl5Meta?.name ?? "users-profile-connections",
    path: connectionst8syvFbgl5Meta?.path ?? "/users/profile/connections",
    meta: connectionst8syvFbgl5Meta || {},
    alias: connectionst8syvFbgl5Meta?.alias || [],
    redirect: connectionst8syvFbgl5Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/connections.vue").then(m => m.default || m)
  },
  {
    name: eventszWIiS0JfhMMeta?.name ?? "users-profile-events",
    path: eventszWIiS0JfhMMeta?.path ?? "/users/profile/events",
    meta: eventszWIiS0JfhMMeta || {},
    alias: eventszWIiS0JfhMMeta?.alias || [],
    redirect: eventszWIiS0JfhMMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/events.vue").then(m => m.default || m)
  },
  {
    name: faved_45businessesuhp3KdNpITMeta?.name ?? "users-profile-faved-businesses",
    path: faved_45businessesuhp3KdNpITMeta?.path ?? "/users/profile/faved-businesses",
    meta: faved_45businessesuhp3KdNpITMeta || {},
    alias: faved_45businessesuhp3KdNpITMeta?.alias || [],
    redirect: faved_45businessesuhp3KdNpITMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/faved-businesses.vue").then(m => m.default || m)
  },
  {
    name: indexsLYt1VEImkMeta?.name ?? "users-profile",
    path: indexsLYt1VEImkMeta?.path ?? "/users/profile",
    meta: indexsLYt1VEImkMeta || {},
    alias: indexsLYt1VEImkMeta?.alias || [],
    redirect: indexsLYt1VEImkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/index.vue").then(m => m.default || m)
  },
  {
    name: liked_45postsalNbS8FUzRMeta?.name ?? "users-profile-liked-posts",
    path: liked_45postsalNbS8FUzRMeta?.path ?? "/users/profile/liked-posts",
    meta: liked_45postsalNbS8FUzRMeta || {},
    alias: liked_45postsalNbS8FUzRMeta?.alias || [],
    redirect: liked_45postsalNbS8FUzRMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/profile/liked-posts.vue").then(m => m.default || m)
  },
  {
    name: waiting_45for_45removalpjGYgQBYZ5Meta?.name ?? "users-waiting-for-removal",
    path: waiting_45for_45removalpjGYgQBYZ5Meta?.path ?? "/users/waiting-for-removal",
    meta: waiting_45for_45removalpjGYgQBYZ5Meta || {},
    alias: waiting_45for_45removalpjGYgQBYZ5Meta?.alias || [],
    redirect: waiting_45for_45removalpjGYgQBYZ5Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/users/waiting-for-removal.vue").then(m => m.default || m)
  }
]